import { createStore } from 'vuex'
import axios from 'axios'
import router from '../router'
import Swal from 'sweetalert2';
import * as firebase from '../firebase';
import * as db from '../firestore';
import { getAuth } from "firebase/auth";

function showError(returnBack, msg) {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    html: msg,
  }).then((result) => {
    if (result.isConfirmed && returnBack) {
      router.back();
    }
  })
}

export default createStore({
  state: {
    isAuthenticated: false,
    isAdmin: false,
    isLoading: false,
    permissions: [],
    notifications: [],
    notifications_unread: false,
    user:{
      id:null,
      email:null,
      photo:null,
      photo_url:null,
      photo_name:null,
      photo_size:null,

      first_name:null,
      last_name:null,
      email:null,
      is_superuser:true,
      is_active:true,
      role:'ventas',
      group:null,
      last_login:null,
      fullname:null,
    },
    almacen:[],
    cliente:[],
    entrada:[],
    entradas:[],
    informacion:[],
    insumo:[],
    negocios:[],
    produto:[],
    recibo:[],
    saldoinsumo:[],
    saldoproducto:[],
    salida:[],
    salidas:[],
    solicitudes:[],
    sucursal:[],
    transferencia:[],
    venta:[],
  },
  mutations: {
    async getAllDates(state) {
      /*state.almacen=await db.getCollection('almacenes');
      state.cliente=await db.getCollection('cliente');
      state.entrada=await db.getCollection('entrada');
      state.entradas=await db.getCollection('entradas');
      state.informacion=await db.getCollection('informacion');
      state.insumo=await db.getCollection('insumo');
      state.negocios=await db.getCollection('negocios');
      state.produto=await db.getCollection('produtos');
      state.recibo=await db.getCollection('recibo');
      state.saldoinsumo=await db.getCollection('saldoinsumo');
      state.saldoproducto=await db.getCollection('saldoproducto');
      state.salida=await db.getCollection('salida');
      state.salidas=await db.getCollection('salidas');
      state.solicitudes=await db.getCollection('solicitudes');
      state.sucursal=await db.getCollection('sucursales');
      state.transferencia=await db.getCollection('transferencia');
      state.venta=await db.getCollection('venta');*/
    },
    setIsLoading(state, status) {
      state.isLoading=status;
    },
    logout(state) {
      console.log("Salir");
      state.isLoading=true;
      /*axios.post('api/v1/auth/logout').then(response => {
        state.isAuthenticated=false;
        state.isAdmin=false;
        state.permissions=[];
        localStorage.setItem("isAuthenticated",false);
        localStorage.setItem("isAdmin",false);
        router.push('/login');
      }).catch(error => {
        state.isAuthenticated=false;
        state.isAdmin=false;
        state.permissions=[];
        localStorage.setItem("isAuthenticated",false);
        localStorage.setItem("isAdmin",false);
        router.push('/login');
      });*/
      router.push('/login');
      state.isLoading=false;
    },
    getLocalStorage(state) {
      state.isAuthenticated=localStorage.getItem('isAuthenticated',false);
      state.isAdmin=localStorage.getItem('isAdmin',false);
      state.permissions=JSON.parse(localStorage.getItem('permissions',"[]"));
    },
    setAuth(state,status) {
      localStorage.setItem('isAuthenticated',status)
      state.isAuthenticated=status;
    },
    setAdmin(state,status) {
      localStorage.setItem('isAdmin',status)
      state.isAdmin=status;
    },
    getPermissions(state) {
      /*if (state.isAuthenticated) {
        axios.post('api/v1/auth/getPermissions').then(response => {
          state.permissions=[];
          response.data.permissions.forEach(element => {
            state.permissions.push(element);
          });
          localStorage.setItem("permissions",JSON.stringify(state.permissions));
        });
      }*/
    },
    showError(state,object) {
      console.log(object);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        html: object.msg,
      }).then((result) => {
        if (result.isConfirmed && object.returnBack) {
          router.back();
        }
      })
    },
    processError(state,obj) {
      showError(obj.returnBack,obj.message);
    },
    routerTo(state,item) {
      //console.log(item);
      if ('permission' in item) {
        var allow=false;
        state.permissions.forEach(element => {
          if (element.includes(item.permission)) {
            allow=true;
          }
        });
        if (allow) {
          if ('params' in item) {
            router.push({name:item.href,params:item.params});
          } else {
            router.push({name:item.href});
          }
        } else {
          var message="No tienes permiso para realizar esta acción.";
          showError(false,message);
        }
      } else {
        router.push({name:item.href});
      }
    },
    formatDate(state,date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
      return [year, month, day].join('-');
    },
    updates(state) {
      /*axios.get('api/v1/user/notification').then(response => {
        state.notifications=response.data;
        var count=0;
        state.notifications.forEach(element => {
          if (!element.read) {
            count++;
          }
        });
        if (count>0) {
          state.notifications_unread=true;
        } else {
          state.notifications_unread=false;
        }
      })*/
    },
    readNotifications(state) {
      /*axios.put('api/v1/user/notification').then(response => {
        //console.log("leidos");
      })*/
    },
    storeUser(state,data) {
      //console.log(data);
      state.user=data;
      state.user.initials=state.user.first_name.toUpperCase()[0]+state.user.last_name.toUpperCase()[0]
    }
  },
  actions: {
    async getCrsf() {
      /*await axios.get('api/v1/getCsrf').then(response => {
        //console.log(response);
      });*/
      console.log("getCrsf");
    },
    async verifiedLogin({ commit }) {
      const user = await firebase.getCurrentUser();
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        // ...
        //console.log(response);
        var userData=await db.getDocument('users',user.uid);
        commit('setAuth',true);
        commit('getPermissions');
        if (userData.is_superuser) {
          commit('setAdmin',true);
          console.log("adddmin");
        } else {
          commit('setAdmin',false);
        }
        console.log("aaaa",userData);
        userData.permissions=(await db.getDocument('group',userData.group))['permissions'];
        console.log("aaaa",userData);
        commit('storeUser',userData);
      } else {
        // No user is signed in.
        console.log("Error Verified");
        commit('setAuth',false);
        router.push('/login');
        var returnBack=false;
      }
    },
    async havePermission({dispatch,commit}) {

    }
  },
  modules: {
  }
})